// Persistencia del usuario verificado para hidratar el rol de forma síncrona
// al recargar la página. El token sigue viviendo en su propia clave
// ('ArbolEc_token'); aquí solo se guarda el snapshot del usuario (rol,
// tenants asignados, etc.) que devuelve /auth/is-verify.
export const TOKEN_STORAGE_KEY = 'ArbolEc_token'
export const USER_STORAGE_KEY = 'ArbolEc_user'

// Lee el usuario persistido. Retorna el objeto userLocal
// ({ auth, user: { rol, assignedTenants, ... } }) o null si no existe o está corrupto.
export const loadStoredUser = () => {
  try {
    const raw = window.localStorage.getItem(USER_STORAGE_KEY)
    return raw ? JSON.parse(raw) : null
  } catch (error) {
    return null
  }
}

export const saveStoredUser = userLocal => {
  try {
    window.localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(userLocal))
  } catch (error) {
    console.warn('No se pudo persistir la sesión:', error)
  }
}

// Limpia token y usuario juntos para mantener la sesión consistente.
export const clearStoredUser = () => {
  window.localStorage.removeItem(USER_STORAGE_KEY)
  window.localStorage.removeItem(TOKEN_STORAGE_KEY)
}
